module.exports = __webpack_public_path__ + "img/content_bg1.4ee5909.png";